import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  finalizeOrder: {
    padding: '0',
    flex: 1,
    gap: '0',
    '@media (min-width: 640px)': {
      backgroundColor: theme.evPalette.charcoal[100],
      padding: '16px 24px',
      flex: 1,
      gap: '16px',
    },
  },
  finalizeOrderPanels: {
    display: 'flex',
    flexDirection: 'column',
    '@media (min-width: 640px)': {
      rowGap: theme.spacing(2),
    },
  },
  cancelButton: {
    color: theme.evPalette.charcoal[700],
    fontSize: '16px',
    fontWeight: 400,
    fontFamily: 'Noto Sans',
    fontStyle: 'normal',
    border: 'none',
    '&:hover': {
      border: 'none',
      backgroundColor: theme.evPalette.charcoal[100],
    },
  },
  okayButton: {
    color: '#BB115E',
    fontSize: '16px',
    fontWeight: 400,
    fontFamily: 'Noto Sans',
    fontStyle: 'normal',
    border: 'none',
    backgroundColor: 'white',
    '&:hover': {
      border: 'none',
      backgroundColor: theme.evPalette.charcoal[100],
    },
  },
}));
